export default __webpack_public_path__ + "static/media/pre-op-4.ac296ff7.jpg";